export const getPodPrice = products => {
  let pod,
    podPrice = null;

  for (const product in products) {
    pod = products[product].variants.find(
      variant => variant.category === 'pods' && variant.price
    );
    if (pod) {
      podPrice = pod.price;
      break;
    }
  }
  return podPrice;
};



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/utils.js